/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Faq_A7Inputs */

const en_minifier_faq_a7 = /** @type {(inputs: Minifier_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minifying goes through the same parse and re-serialize cycle as formatting, so integers beyond 2^53 are rounded. That is a property of parsing JSON numbers as doubles, not of minification itself. Send large IDs as strings if this matters.`)
};

const ko_minifier_faq_a7 = /** @type {(inputs: Minifier_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`압축도 포매팅과 같은 파싱 및 재직렬화 과정을 거치므로 2^53을 넘는 정수는 반올림됩니다. 이는 압축 자체의 성질이 아니라 JSON 숫자를 double로 파싱하는 것의 성질입니다. 이것이 중요하면 큰 ID를 문자열로 보내세요.`)
};

const ja_minifier_faq_a7 = /** @type {(inputs: Minifier_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧縮も整形と同じパースと再シリアライズの過程を通るため、2^53 を超える整数は丸められます。これは圧縮自体の性質ではなく、JSON の数値を double としてパースすることの性質です。これが問題になるなら大きな ID を文字列で送ってください。`)
};

/**
* | output |
* | --- |
* | "Minifying goes through the same parse and re-serialize cycle as formatting, so integers beyond 2^53 are rounded. That is a property of parsing JSON numbers a..." |
*
* @param {Minifier_Faq_A7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_faq_a7 = /** @type {((inputs?: Minifier_Faq_A7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Faq_A7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_faq_a7(inputs)
	if (locale === "ko") return ko_minifier_faq_a7(inputs)
	return ja_minifier_faq_a7(inputs)
});